import axiosInstance from "./httpInterceptor";

export const jobsService = {
  /**
   * Fetch aggregated hiring intelligence for a competitor.
   * @param {string} companyId - MongoDB company ID of the selected competitor
   * @param {string} preset    - Date preset key (e.g. "LAST_QUARTER")
   */
  getExpansionTrends: (companyId, preset) =>
    axiosInstance.get("/v1/jobs/expansion-trends", {
      params: { companyId, preset },
    }),

  /**
   * Trigger an immediate jobs scrape for all companies (ADMIN only).
   * @param {number} limit - Max jobs per company (default 50)
   */
  triggerJobsScraper: (limit = 50) =>
    axiosInstance.post("/v1/jobs/scraper/run", null, {
      params: { limit },
    }),

  /**
   * Fetch pre-computed expansion insights for a competitor or the market.
   * Passing companyId="market_trends" returns market-level insights.
   * Returns 204 (resolved as null) before the first scraper run completes.
   * @param {string} companyId - MongoDB company ID, or "market_trends"
   */
  getExpansionInsights: (companyId) =>
    axiosInstance.get("/v1/jobs/expansion-insights", {
      params: { companyId },
    }),

  /**
   * Fetch per-company monthly hiring velocity for the Market Trends stacked chart.
   * @param {string} preset - Date preset key (e.g. "LAST_QUARTER")
   */
  getMarketVelocity: (preset) =>
    axiosInstance.get("/v1/jobs/market-velocity", {
      params: { preset },
    }),
};
